<template>
  <MainLayout>
    <div class="flex px-2 py-1">
      <Notification />

      <Complaint />
    </div>
  </MainLayout>
</template>

<script>
import Notification from "./Notification";
import Complaint from "./Complaint";

export default {
  metaInfo: {
    title: "System Monitoring",
    meta: [{ name: "System Monitoring", content: "system monitoring" }]
  },

  components: {
    Notification,
    Complaint
  }
};
</script>
